module.exports = __webpack_public_path__ + "media/images/top/keisan_dojo_drill_result-min-180310b597885b37c34914e23affcd81.png";